var _objectWithoutProperties = require("D:\\Applications\\Portals\\QuoteAndBuy\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("D:\\Applications\\Portals\\QuoteAndBuy\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _defineProperty = require("D:\\Applications\\Portals\\QuoteAndBuy\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/array/from.js": function node_modulesBabelRuntimeCorejs3CoreJsArrayFromJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/array/from");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/array/is-array.js": function node_modulesBabelRuntimeCorejs3CoreJsArrayIsArrayJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/array/is-array");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/get-iterator.js": function node_modulesBabelRuntimeCorejs3CoreJsGetIteratorJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/get-iterator");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/instance/slice.js": function node_modulesBabelRuntimeCorejs3CoreJsInstanceSliceJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/instance/slice");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/is-iterable.js": function node_modulesBabelRuntimeCorejs3CoreJsIsIterableJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/is-iterable");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/symbol.js": function node_modulesBabelRuntimeCorejs3CoreJsSymbolJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/symbol");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/arrayLikeToArray.js": function node_modulesBabelRuntimeCorejs3HelpersArrayLikeToArrayJs(module, exports) {
    module.exports = function (arr, len) {
      (null == len || len > arr.length) && (len = arr.length);

      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js": function node_modulesBabelRuntimeCorejs3HelpersArrayWithHolesJs(module, exports, __webpack_require__) {
    var _Array$isArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/array/is-array.js");

    module.exports = function (arr) {
      if (_Array$isArray(arr)) return arr;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/iterableToArrayLimit.js": function node_modulesBabelRuntimeCorejs3HelpersIterableToArrayLimitJs(module, exports, __webpack_require__) {
    var _getIterator = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/get-iterator.js"),
        _isIterable = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/is-iterable.js"),
        _Symbol = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/symbol.js");

    module.exports = function (arr, i) {
      if (void 0 !== _Symbol && _isIterable(Object(arr))) {
        var _arr = [],
            _n = !0,
            _d = !1,
            _e = void 0;

        try {
          for (var _s, _i = _getIterator(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !i || _arr.length !== i); _n = !0) {
            ;
          }
        } catch (err) {
          _d = !0, _e = err;
        } finally {
          try {
            _n || null == _i.return || _i.return();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/nonIterableRest.js": function node_modulesBabelRuntimeCorejs3HelpersNonIterableRestJs(module, exports) {
    module.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/slicedToArray.js": function node_modulesBabelRuntimeCorejs3HelpersSlicedToArrayJs(module, exports, __webpack_require__) {
    var arrayWithHoles = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js"),
        iterableToArrayLimit = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/iterableToArrayLimit.js"),
        unsupportedIterableToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/unsupportedIterableToArray.js"),
        nonIterableRest = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/nonIterableRest.js");

    module.exports = function (arr, i) {
      return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/unsupportedIterableToArray.js": function node_modulesBabelRuntimeCorejs3HelpersUnsupportedIterableToArrayJs(module, exports, __webpack_require__) {
    var _Array$from = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/array/from.js"),
        _sliceInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/slice.js"),
        arrayLikeToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/arrayLikeToArray.js");

    module.exports = function (o, minLen) {
      var _context;

      if (o) {
        if ("string" == typeof o) return arrayLikeToArray(o, minLen);

        var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

        return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? _Array$from(o) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? arrayLikeToArray(o, minLen) : void 0;
      }
    };
  },
  "./AuthTokenStorage.js": function AuthTokenStorageJs(module, exports) {
    var tokenStorage = {},
        getTokenByKey = function getTokenByKey(key) {
      return tokenStorage[key];
    };

    module.exports = {
      getTokenByKey: getTokenByKey,
      getAccessToken: function getAccessToken() {
        return getTokenByKey("accessToken");
      },
      getIdToken: function getIdToken() {
        return getTokenByKey("idToken");
      },
      setToken: function setToken(key, token) {
        tokenStorage[key] = token;
      },
      removeTokenByKey: function removeTokenByKey(key) {
        delete tokenStorage[key];
      }
    };
  },
  "./index.js": function indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "AuthProvider", function () {
      return AuthProvider;
    }), __webpack_require__.d(__webpack_exports__, "AuthContext", function () {
      return AuthContext;
    }), __webpack_require__.d(__webpack_exports__, "getTokenByKey", function () {
      return AuthTokenStorage.getTokenByKey;
    }), __webpack_require__.d(__webpack_exports__, "getAccessToken", function () {
      return AuthTokenStorage.getAccessToken;
    }), __webpack_require__.d(__webpack_exports__, "getIdToken", function () {
      return AuthTokenStorage.getIdToken;
    }), __webpack_require__.d(__webpack_exports__, "SecureRoute", function () {
      return SecureRoute;
    }), __webpack_require__.d(__webpack_exports__, "decodeJWTTokenPayload", function () {
      return decodeJWTTokenPayload;
    });

    var index_of_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/index-of"),
        index_of_default = __webpack_require__.n(index_of_),
        external_react_ = __webpack_require__("react"),
        external_react_default = __webpack_require__.n(external_react_),
        okta_react_ = __webpack_require__("@okta/okta-react"),
        external_react_router_dom_ = __webpack_require__("react-router-dom"),
        config_ = __webpack_require__("@jutro/config"),
        logger_ = __webpack_require__("@jutro/logger"),
        includes_ = (__webpack_require__("core-js/modules/es.string.replace"), __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/includes")),
        includes_default = __webpack_require__.n(includes_),
        concat_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/concat"),
        concat_default = __webpack_require__.n(concat_),
        slicedToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/slicedToArray.js"),
        slicedToArray_default = __webpack_require__.n(slicedToArray),
        external_lodash_ = __webpack_require__("lodash"),
        external_lodash_default = __webpack_require__.n(external_lodash_),
        AuthTokenStorage = __webpack_require__("./AuthTokenStorage.js");

    var AuthContext = Object(external_react_.createContext)(),
        AuthContextProviderInternal = function AuthContextProviderInternal(_ref) {
      var children = _ref.children;

      var _authService$_oktaAut, _authService$_oktaAut3, _authService$_oktaAut4;

      var _useOktaAuth = Object(okta_react_.useOktaAuth)(),
          authState = _useOktaAuth.authState,
          authService = _useOktaAuth.authService,
          isPending = authState.isPending,
          authenticated = authState.isAuthenticated,
          tokenManager = null == authService || null === (_authService$_oktaAut = authService._oktaAuth) || void 0 === _authService$_oktaAut ? void 0 : _authService$_oktaAut.tokenManager,
          basenameUri = Object(config_.getConfigValue)("JUTRO_ROUTER_BASENAME", ""),
          _useState = Object(external_react_.useState)({}),
          _useState2 = slicedToArray_default()(_useState, 2),
          authentication = _useState2[0],
          setAuthentication = _useState2[1];

      Object(external_react_.useEffect)(function () {
        (function _callee() {
          var _decodedAccessToken$p, currentUserInfo, decodedAccessToken, update;

          return _regeneratorRuntime.async(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!authenticated) {
                    _context2.next = 10;
                    break;
                  }

                  _context2.next = 3;
                  return _regeneratorRuntime.awrap(authService.getUser());

                case 3:
                  currentUserInfo = _context2.sent;
                  _context2.next = 6;
                  return _regeneratorRuntime.awrap(getDecodedAccessToken());

                case 6:
                  decodedAccessToken = _context2.sent;
                  currentUserInfo.groups = null == decodedAccessToken || null === (_decodedAccessToken$p = decodedAccessToken.payload) || void 0 === _decodedAccessToken$p ? void 0 : _decodedAccessToken$p.groups, update = {
                    userInfo: currentUserInfo
                  }, setAuthentication(function (prev) {
                    return _objectSpread({}, prev, {}, update);
                  });
                  _context2.next = 11;
                  break;

                case 10:
                  setAuthentication({
                    tokenManager: tokenManager
                  });

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, null, null, null, Promise);
        })();
      }, [authenticated, authService]), Object(external_react_.useEffect)(function () {
        var _authService$getAcces, _authService$getIdTok;

        return null == authService || null === (_authService$getAcces = authService.getAccessToken) || void 0 === _authService$getAcces || _authService$getAcces.call(authService).then(function (result) {
          Object(AuthTokenStorage.setToken)("accessToken", result);
        }), null == authService || null === (_authService$getIdTok = authService.getIdToken) || void 0 === _authService$getIdTok || _authService$getIdTok.call(authService).then(function (result) {
          Object(AuthTokenStorage.setToken)("idToken", result);
        }), subscribeTokenManager(), unSubscribeTokenManager;
      }, [authService]);

      var subscribeTokenManager = function subscribeTokenManager() {
        var autoRenew = Object(config_.getConfigValue)("JUTRO_AUTH_AUTO_RENEW", !0);
        null == tokenManager || tokenManager.on("expired", function (key) {
          Object(AuthTokenStorage.removeTokenByKey)(key), !autoRenew && logout();
        }), null == tokenManager || tokenManager.on("renewed", function (key, newToken) {
          Object(AuthTokenStorage.setToken)(key, newToken);
        });
      },
          unSubscribeTokenManager = function unSubscribeTokenManager() {
        var _tokenManager$off, _tokenManager$off2;

        null == tokenManager || null === (_tokenManager$off = tokenManager.off) || void 0 === _tokenManager$off || _tokenManager$off.call(tokenManager, "expired"), null == tokenManager || null === (_tokenManager$off2 = tokenManager.off) || void 0 === _tokenManager$off2 || _tokenManager$off2.call(tokenManager, "renewed");
      },
          allocateToken = function allocateToken(scopes, newTokenKey) {
        var _authService$_oktaAut2, _authService$_config, _newTokens$tokens, errorMsg, _errorMsg, token, defaultScopes, newTokens, accessTokenWrapper;

        return _regeneratorRuntime.async(function allocateToken$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!scopes || 0 === scopes.length)) {
                  _context3.next = 3;
                  break;
                }

                errorMsg = "scopes are not provided";
                return _context3.abrupt("return", void Object(logger_.error)(errorMsg));

              case 3:
                if (newTokenKey) {
                  _context3.next = 6;
                  break;
                }

                _errorMsg = "newTokenKey is not provided";
                return _context3.abrupt("return", void Object(logger_.error)(_errorMsg));

              case 6:
                token = null == authService || null === (_authService$_oktaAut2 = authService._oktaAuth) || void 0 === _authService$_oktaAut2 ? void 0 : _authService$_oktaAut2.token, defaultScopes = null == authService || null === (_authService$_config = authService._config) || void 0 === _authService$_config ? void 0 : _authService$_config.scope;
                scopes = external_lodash_default.a.uniq(concat_default()(defaultScopes).call(defaultScopes, scopes));
                _context3.next = 10;
                return _regeneratorRuntime.awrap(token.getWithoutPrompt({
                  scopes: scopes
                }));

              case 10:
                newTokens = _context3.sent;
                accessTokenWrapper = null == newTokens || null === (_newTokens$tokens = newTokens.tokens) || void 0 === _newTokens$tokens ? void 0 : _newTokens$tokens.accessToken;
                return _context3.abrupt("return", (Object(AuthTokenStorage.setToken)(newTokenKey, null == accessTokenWrapper ? void 0 : accessTokenWrapper.accessToken), tokenManager.add(newTokenKey, accessTokenWrapper), Object(AuthTokenStorage.getTokenByKey)(newTokenKey)));

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, null, null, null, Promise);
      },
          login = function login(fromUri) {
        var additionalParams,
            loginRedirectFallBack,
            loginUri,
            idp,
            params,
            _args3 = arguments;
        return _regeneratorRuntime.async(function login$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                additionalParams = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                loginRedirectFallBack = "".concat(window.location.pathname).concat(window.location.search).replace(basenameUri, "");
                loginUri = external_lodash_default.a.isString(fromUri) ? fromUri : Object(config_.getConfigValue)("JUTRO_AUTH_LOGIN_REDIRECT_PATH", loginRedirectFallBack);
                includes_default()(loginUri).call(loginUri, "/logout") && (loginUri = "/");
                idp = Object(config_.getConfigValue)("JUTRO_AUTH_IDP"), params = _objectSpread({}, idp ? {
                  idp: idp
                } : idp, {}, additionalParams);
                _context4.next = 7;
                return _regeneratorRuntime.awrap(authService.login("".concat(basenameUri).concat(loginUri), params));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, null, null, null, Promise);
      },
          logout = function logout(fromUri) {
        var logoutUri;
        return _regeneratorRuntime.async(function logout$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                logoutUri = external_lodash_default.a.isString(fromUri) ? fromUri : Object(config_.getConfigValue)("JUTRO_AUTH_LOGOUT_REDIRECT_PATH", "/logout");
                return _context5.abrupt("return", authService.logout("".concat(basenameUri).concat(logoutUri)).catch(function (err) {
                  var errorCode = err.errorCode,
                      errorMsg = "Jutro Auth logout failure: " + errorCode;
                  if (Object(logger_.error)(errorMsg), "E0000007" !== errorCode) throw new Error(errorMsg);
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, null, null, null, Promise);
      },
          getAccessToken = function getAccessToken() {
        return authService.getAccessToken();
      },
          getIdToken = function getIdToken() {
        return authService.getIdToken();
      },
          decodeFunction = (null == authService || null === (_authService$_oktaAut3 = authService._oktaAuth) || void 0 === _authService$_oktaAut3 || null === (_authService$_oktaAut4 = _authService$_oktaAut3.token) || void 0 === _authService$_oktaAut4 ? void 0 : _authService$_oktaAut4.decode) || function () {
        return null;
      },
          decodeIdToken = function decodeIdToken(token) {
        var decoder = decodeFunction;
        return console.log("DEPRECATED - decodeIdToken() has been deprecated. Please use decodeToken() instead"), decoder(token);
      },
          decodeToken = function decodeToken(token) {
        return decodeFunction(token);
      },
          getDecodedIdToken = function getDecodedIdToken() {
        var token;
        return _regeneratorRuntime.async(function getDecodedIdToken$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _regeneratorRuntime.awrap(getIdToken());

              case 2:
                token = _context6.sent;
                return _context6.abrupt("return", decodeToken(token));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, null, null, null, Promise);
      },
          getDecodedAccessToken = function getDecodedAccessToken() {
        var token;
        return _regeneratorRuntime.async(function getDecodedAccessToken$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _regeneratorRuntime.awrap(getAccessToken());

              case 2:
                token = _context7.sent;
                return _context7.abrupt("return", decodeToken(token));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, null, null, null, Promise);
      };

      return external_react_default.a.createElement(AuthContext.Provider, {
        value: _objectSpread({
          authenticated: !!authenticated,
          isPending: !!isPending
        }, authentication, {
          allocateToken: allocateToken,
          decodeIdToken: decodeIdToken,
          decodeToken: decodeToken,
          getAccessToken: getAccessToken,
          getDecodedIdToken: getDecodedIdToken,
          getDecodedAccessToken: getDecodedAccessToken,
          getIdToken: getIdToken,
          login: login,
          logout: logout
        })
      }, children);
    };

    AuthContextProviderInternal.displayName = "AuthContextProvider";
    var AuthContextProvider = AuthContextProviderInternal;
    AuthContextProviderInternal.__docgenInfo = {
      componentName: "AuthContextProvider",
      packageName: "@jutro/auth",
      description: "",
      displayName: "AuthContextProvider",
      methods: [],
      actualName: "AuthContextProviderInternal"
    };

    var getTokenManagerConfig = function getTokenManagerConfig() {
      var expireEarlySeconds = Object(config_.getConfigValue)("JUTRO_AUTH_EXPIRE_EARLY_SECONDS", 30),
          autoRenew = Object(config_.getConfigValue)("JUTRO_AUTH_AUTO_RENEW", !0),
          storage = Object(config_.getConfigValue)("JUTRO_AUTH_STORAGE", "localStorage");
      return "cookie" === storage && Object(logger_.warning)("cookie storage option is not recommended as it's not secure"), {
        expireEarlySeconds: expireEarlySeconds,
        storage: storage,
        autoRenew: autoRenew
      };
    },
        AuthProvider = function AuthProvider(_ref2) {
      var children = _ref2.children,
          onAuthSessionExpired = _ref2.onAuthSessionExpired;
      var authConfig = {
        isEnabled: Object(config_.getConfigValue)("JUTRO_AUTH_ENABLED", !1),
        issuer: Object(config_.getConfigValue)("JUTRO_AUTH_ISSUER", ""),
        clientId: Object(config_.getConfigValue)("JUTRO_AUTH_CLIENT_ID", ""),
        redirectBase: Object(config_.getConfigValue)("JUTRO_AUTH_REDIRECT_BASE", window.location.origin),
        redirectPath: Object(config_.getConfigValue)("JUTRO_AUTH_REDIRECT_PATH", ""),
        scope: Object(config_.getConfigValue)("JUTRO_AUTH_SCOPE", "openid,profile,email"),
        pkce: Object(config_.getConfigValue)("JUTRO_AUTH_PKCE_ENABLED", !1),
        tokenManager: getTokenManagerConfig()
      };

      if (authConfig.isEnabled) {
        var issuer = authConfig.issuer,
            clientId = authConfig.clientId,
            redirectPath = authConfig.redirectPath,
            pkce = authConfig.pkce,
            tokenManager = authConfig.tokenManager,
            redirectUri = "".concat(authConfig.redirectBase).concat(redirectPath),
            scopes = authConfig.scope.split(",");
        return -1 === index_of_default()(scopes).call(scopes, "openid") && scopes.push("openid"), external_react_default.a.createElement(okta_react_.Security, {
          issuer: issuer,
          client_id: clientId,
          redirect_uri: redirectUri,
          scope: scopes,
          pkce: pkce,
          tokenManager: tokenManager,
          onSessionExpired: onAuthSessionExpired
        }, external_react_default.a.createElement(external_react_router_dom_.Switch, null, external_react_default.a.createElement(external_react_router_dom_.Route, {
          path: redirectPath,
          component: okta_react_.LoginCallback
        }), external_react_default.a.createElement(AuthContextProvider, null, children)));
      }

      return children;
    };

    AuthProvider.__docgenInfo = {
      componentName: "AuthProvider",
      packageName: "@jutro/auth",
      description: "A HOC that wraps children components in Okta Security. This will initialize the\nokta configuration and set up a callback route to handle the login redirect.\nWrapping will only happen if authentication is enabled, otherwise the original\ncomponent will be returned, unwrapped.",
      displayName: "AuthProvider",
      methods: [],
      actualName: "AuthProvider"
    };

    var external_prop_types_ = __webpack_require__("prop-types"),
        external_prop_types_default = __webpack_require__.n(external_prop_types_);

    var secureRoutePropTypes = _objectSpread({}, external_react_router_dom_.Route.propTypes, {
      children: external_prop_types_default.a.func,
      component: external_prop_types_default.a.elementType,
      render: external_prop_types_default.a.func
    }),
        SecureRoute = function SecureRoute(_ref3) {
      var children = _ref3.children,
          Component = _ref3.component,
          render = _ref3.render,
          props = _objectWithoutProperties(_ref3, ["children", "component", "render"]);

      var auth = Object(external_react_.useContext)(AuthContext);
      return !auth || auth.authenticated || auth.isPending || auth.login(), external_react_default.a.createElement(external_react_router_dom_.Route, props, function (routeProps) {
        return children ? children(_objectSpread({}, routeProps, {
          auth: auth
        })) : Component ? auth ? (null == auth ? void 0 : auth.authenticated) && external_react_default.a.createElement(Component, routeProps) : external_react_default.a.createElement(Component, routeProps) : render ? render(_objectSpread({}, routeProps, {
          auth: auth
        })) : null;
      });
    };

    SecureRoute.propTypes = secureRoutePropTypes, SecureRoute.displayName = "SecureRoute", SecureRoute.__docgenInfo = {
      componentName: "SecureRoute",
      packageName: "@jutro/auth",
      description: "Route which requires authentication\nInspired by Octa's SecureRoute\nhttps://github.com/okta/okta-oidc-js/blob/master/packages/okta-react/src/SecureRoute.js\nhttps://github.com/okta/okta-oidc-js/blob/8fe896a383fc5e02999d63068175e72bec538115/packages/okta-react/src/SecureRoute.js",
      displayName: "SecureRoute",
      methods: [],
      actualName: "SecureRoute",
      props: {
        children: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Functions called when rendering route. Takes precedence over component and render\n({ auth: Auth, ...routeProps }) => React.ReactNode"
        },
        component: {
          type: {
            name: "elementType"
          },
          required: !1,
          description: "Component to be render when authenticated. Takes precedence over render"
        },
        render: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Functions called when rendering route\n({ auth: Auth, ...routeProps }) => React.ReactNode"
        }
      },
      composes: ["react-router-dom"]
    };

    var decodeJWTTokenPayload = function decodeJWTTokenPayload(token) {
      return JSON.parse(atob(token.split(".")[1]));
    };
  },
  "@babel/runtime-corejs3/core-js-stable/instance/concat": function babelRuntimeCorejs3CoreJsStableInstanceConcat(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/concat");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/includes": function babelRuntimeCorejs3CoreJsStableInstanceIncludes(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/includes");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/index-of": function babelRuntimeCorejs3CoreJsStableInstanceIndexOf(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/index-of");
  },
  "@jutro/config": function jutroConfig(module, exports) {
    module.exports = require("@jutro/config");
  },
  "@jutro/logger": function jutroLogger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "@okta/okta-react": function oktaOktaReact(module, exports) {
    module.exports = require("@okta/okta-react");
  },
  "core-js-pure/features/array/from": function coreJsPureFeaturesArrayFrom(module, exports) {
    module.exports = require("core-js-pure/features/array/from");
  },
  "core-js-pure/features/array/is-array": function coreJsPureFeaturesArrayIsArray(module, exports) {
    module.exports = require("core-js-pure/features/array/is-array");
  },
  "core-js-pure/features/get-iterator": function coreJsPureFeaturesGetIterator(module, exports) {
    module.exports = require("core-js-pure/features/get-iterator");
  },
  "core-js-pure/features/instance/slice": function coreJsPureFeaturesInstanceSlice(module, exports) {
    module.exports = require("core-js-pure/features/instance/slice");
  },
  "core-js-pure/features/is-iterable": function coreJsPureFeaturesIsIterable(module, exports) {
    module.exports = require("core-js-pure/features/is-iterable");
  },
  "core-js-pure/features/symbol": function coreJsPureFeaturesSymbol(module, exports) {
    module.exports = require("core-js-pure/features/symbol");
  },
  "core-js/modules/es.string.replace": function coreJsModulesEsStringReplace(module, exports) {
    module.exports = require("core-js/modules/es.string.replace");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  },
  "prop-types": function propTypes(module, exports) {
    module.exports = require("prop-types");
  },
  react: function react(module, exports) {
    module.exports = require("react");
  },
  "react-router-dom": function reactRouterDom(module, exports) {
    module.exports = require("react-router-dom");
  }
});